<template>
  <div class="grid">
    <p class="payment-invoice__row">
      <span>Transacción: </span>
      <span
        id="pagoExitoso"
        class="text-success"
      >
        APROBADA</span>
    </p>
    <p class="payment-invoice__row">
      <span>Teléfono: </span>
      <span> {{ info.phone | formatPhone(0) }}</span>
    </p>
    <p class="payment-invoice__row">
      <span>Monto pagado: </span>
      <span> {{ info.amount }}</span>
    </p>
    <p class="payment-invoice__row">
      <span>Número de autorización: </span>
      <span>{{ info.authCode }}</span>
    </p>
    <p class="payment-invoice__row">
      <span>Fecha y hora: </span>
      <span>{{ info.operationDate | localHour(false) }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'PaymentInvoice',
  props: { info: { type: Object, required: true } }
};
</script>

<style>
.payment-invoice__row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
  font-weight: bold;
}
</style>
